import React from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import NewJobOfferCard from "../../../Candidate/components/NewJobOfferCard";

const CompanyJobsTab = ({ jobOffers }) => {
  const intl = useIntl();
  const i18nLocale = useSelector((state) => state.i18nLocale);

  return (
    <Box>
      {jobOffers.length > 0 && (
        <Typography
          sx={{
            fontSize: "1.25rem",
            color: "hsl(222.2, 84%, 4.9%)",
            letterSpacing: "-0.01em",
            fontFamily: "Segoe UI Bold, system-ui, sans-serif",
            borderBottom: "2px solid hsl(152, 60%, 32%)",
            pb: "0.25rem",
            mb: 2.5,
            display: "inline-block",
          }}
        >
          {intl.formatMessage({ id: "company_view.jobs.count" }, { count: jobOffers.length })}
        </Typography>
      )}
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1.5 }}>
        {jobOffers.map((job) => (
          <NewJobOfferCard
            key={job.id}
            offer={job}
            hideDescription
            onClick={() => {
              window.location.href = `/${i18nLocale}/job-offers/${job.id}`;
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default CompanyJobsTab;
